import { CurrencyPipe } from "@angular/common";
import { Component, inject, input, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { OportunityValueChartComponent } from "../../charts/oportunity-value-chart/oportunity-value-chart.component";
import { CLAIM_MUTABLE_STATUS } from "../../../store-management/claims/claim-mutation.helper";
import { OpportunityValueWidgetKpi } from "../../models/dashboard-widget-kpi.model";
import { DashboardListNavigationContext } from "../../models/dashboard-list-navigation.model";
import { DashboardNavigationService } from "../../services/dashboard-navigation.service";

@Component({
  selector: "app-dashboard-opportunity-value-widget",
  standalone: true,
  imports: [
    MaterialModule,
    TranslateModule,
    CurrencyPipe,
    OportunityValueChartComponent,
  ],
  templateUrl: "./opportunity-value-widget.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class OpportunityValueWidgetComponent {
  private readonly navigationSvc = inject(DashboardNavigationService);

  readonly kpi = input.required<OpportunityValueWidgetKpi>();
  readonly listNavigation = input.required<DashboardListNavigationContext>();

  onClaimsNotFiledSelected(): void {
    this.navigationSvc.navigateToClaimsList(
      this.listNavigation(),
      "",
      CLAIM_MUTABLE_STATUS,
    );
  }

  onFiledCasesNotReimbursedSelected(): void {
    this.navigationSvc.navigateToCasesList(
      this.listNavigation(),
      "",
      "without",
    );
  }
}
